// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"4e3e4611","498":"ca0f5951","703":"cceb8c08"}[chunkId] + ".chunk.js";
};